const SM_SHADER_NORMAL = 0;
const SM_SHADER_TEXT = 1;

WL.registerComponent('story-machine', {
    projectPath: {type: WL.Type.String, default: "Test Projects/Grandpas House.spk"},
    material: {type: WL.Type.Material},
    fontMaterial: {type: WL.Type.Material},
}, {
    init: function() {
        this.meshes = [];
        this.textures = [];
        this.canvases = [];
        this.objects = [];
        this.shaderType = [];
        this.sm = null;
        this.forward = new Float32Array(3);
        this.viewForward = new Float32Array(3);
        this.hidden = false;
    },
    start: function() {
        /* Load the wasm and instantiate through it's acompanying .js */
        fetch("SMEngine.wasm")
            .then(r => r.arrayBuffer())
            .then(wasm => {
                const s = document.createElement('script');
                s.onload = () => { this.onStoryMachineWasmLoaded(wasm); };
                s.src = 'SMEngine.js';
                document.body.appendChild(s);
            })
            .catch(console.error);
    },
    onStoryMachineWasmLoaded: function(wasm) {
        /* Set up callbacks for StoryMachine and instantiate Module */
        SMEngine({
            wasm: wasm,
            log: console.log,
            logError: console.error,
            textureUpload: this.textureUpload.bind(this),
            textureUpdate: this.textureUpdate.bind(this),
            drawMeshes: this.drawMeshes.bind(this),
            updateVertexBuffer: this.updateVertexBuffer.bind(this),
            clearGraphicsContext: this.clearGraphicsContext.bind(this),
        }).then((sm) => {
            console.log("SM.js: Engine initialized, loading project.");
            fetch(this.projectPath)
                .then(r => r.arrayBuffer())
                .then(buffer => {
                    if(!sm.SetPlayerPackage(buffer)) {
                        console.error("Package is invalid");
                        return;
                    }

                    sm.LoadProject("project.smp");
                    sm.LoadScene(sm.GetProjectInfo().startScenePath);

                    console.log("SM.js: Scene loaded successfully.");
                    this.sm = sm;

                    this.collider = this.object.addComponent('collision', {
                        collider: WL.Collider.Box,
                        group: ~(1 << 2), /* collision group 2 is reserved for teleport navigation */
                        extents: [10.0, 10.0, 0.25],
                    });
                    this.cursorTarget = this.object.addComponent('cursor-target');

                    const cursorPos = new Float32Array(3);
                    const pos = new Float32Array(3);
                    const rot = new Float32Array(4);
                    const getCursorPos = cursor => {
                        cursorPos.set(cursor.rayHit.locations[0]);
                        this.object.getTranslationWorld(pos);
                        glMatrix.vec3.sub(cursorPos, cursorPos, pos);
                        glMatrix.quat.invert(rot, this.object.rotationWorld);
                        glMatrix.vec3.transformQuat(cursorPos, cursorPos, rot);
                        glMatrix.vec3.div(cursorPos, cursorPos, this.object.scalingWorld);

                        return [cursorPos[0], cursorPos[1]];
                    };

                    let mouseDown = false;
                    this.cursorTarget.addUnHoverFunction((e, cursor) => {
                        mouseDown = false;
                    });

                    const lastMovePos = new Float32Array(2);
                    this.cursorTarget.addHoverFunction((e, cursor) => {
                        mouseDown = false;
                        lastMovePos.set(getCursorPos(cursor));
                    });
                    this.cursorTarget.addMoveFunction((e, cursor) => {
                        const p = getCursorPos(cursor);
                        if(!mouseDown) {
                            sm.MouseMovedEvent(p[0], p[1], p[0] - lastMovePos[0], p[1] - lastMovePos[1]);
                        } else {
                            sm.MouseDragEvent(p[0], p[1], p[0] - lastMovePos[0], p[1] - lastMovePos[1]);
                        }
                        lastMovePos.set(p);
                    });
                    this.cursorTarget.addDownFunction((e, cursor) => {
                        const p = getCursorPos(cursor);
                        sm.MouseDownEvent(p[0], p[1]);
                        mouseDown = true;
                    });
                    this.cursorTarget.addUpFunction((e, cursor) => {
                        const p = getCursorPos(cursor);
                        sm.MouseUpEvent(p[0], p[1]);
                        mouseDown = false;
                    });
                });
        });
    },

    setBinaryData: function(canvas, data, w, h, bytesPerPixel) {
        const ctx = canvas.getContext('2d');
        const imageData = ctx.createImageData(w, h);

        if(bytesPerPixel == 4) {
            imageData.data.set(data);
            ctx.putImageData(imageData, 0, 0);
        } else if(bytesPerPixel == 3) {
            const pixelCount = data.length/3;
            for(let i = 0; i < pixelCount; ++i) {
                const dest = i*4;
                const src = i*3;
                imageData.data[dest + 0] = data[src + 0];
                imageData.data[dest + 1] = data[src + 1];
                imageData.data[dest + 2] = data[src + 2];
                imageData.data[dest + 3] = 255;
            }
            ctx.putImageData(imageData, 0, 0);

        /* Font grayscale image */
        } else if(bytesPerPixel == 1) {
            /* We are never sampling the gba channels, so
             * we just skip those entirely for speed */
            for(let i = 0; i < data.length; ++i) {
                const dest = i*4;
                const src = data[i];
                imageData.data[dest] = src;
                imageData.data[dest + 1] = src;
                imageData.data[dest + 2] = src;
                imageData.data[dest + 3] = 255;
            }
            ctx.putImageData(imageData, 0, 0);

        } else {
            throw new Error("Unsupported pixel size: " + bytesPerPixel.toString() + " bytes");
        }
    },
    textureUpload: function(data, w, h, bytesPerPixel) {
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        this.setBinaryData(canvas, data, w, h, bytesPerPixel);
        const handle = this.canvases.length;
        this.canvases.push(canvas);
        this.shaderType.push(bytesPerPixel == 1 ? SM_SHADER_TEXT : SM_SHADER_NORMAL);
        return handle;
    },
    createTexture: function(handle) {
        if(handle >= this.textures.length) {
            const t = new WL.Texture(this.canvases[handle]);
            this.textures.push(t);
        } else if(this.textures[handle] == null) {
            const t = new WL.Texture(this.canvases[handle]);
            this.textures[handle] = t;
        }
        return this.textures[handle];
    },
    textureUpdate: function(handle, data, w, h, bytesPerPixel) {
        this.setBinaryData(this.canvases[handle], data, w, h, bytesPerPixel);
        this.textures[handle].update();
        console.log("update", handle, bytesPerPixel);
        this.shaderType[handle] = bytesPerPixel == 1 ? SM_SHADER_TEXT : SM_SHADER_NORMAL;
    },
    updateVertexBuffer: function(data, size) {
        for(let i = 0; i < this.meshes.length; ++i) {
            if(!this.meshes[i]) continue;
            /* Backwards compat, destroy was added recently */
            if('destroy' in this.meshes[i]) this.meshes[i].destroy();
            this.meshes[i] = null;
        }
    },
    drawMeshes: function(meshes, vertexBuffer) {
        if(this.hidden) return;
        /*
        Vector2 position;
        Vector2 uv;
        float color[4];
        */
        const VERTEX_SIZE = 8;

        const objects = (this.objects && this.objects.length >= meshes.length) ? this.objects : WL.scene.addObjects(meshes.length, this.object, meshes.length);
        this.objects = objects;
        for(let o = 0; o < meshes.length; ++o) {
            let m = meshes[o];

            let mesh = this.meshes[o];
            if(!mesh) {
                mesh = this.meshes[o] = (this.meshes[o] || new WL.Mesh({vertexCount: m.vertexCount}));
                const positions = mesh.attribute(WL.MeshAttribute.Position);
                const textureCoords = mesh.attribute(WL.MeshAttribute.TextureCoordinate);
                const colors = mesh.attribute(WL.MeshAttribute.Color);

                for(let v = 0; v < m.vertexCount; ++v) {
                    const ptr = (m.vertexBufferOffset + v)*VERTEX_SIZE;
                    positions.set(v, [vertexBuffer[ptr], vertexBuffer[ptr + 1], 0]);
                    textureCoords.set(v, [vertexBuffer[ptr + 2], 1 - vertexBuffer[ptr + 3]]);
                    colors.set(v, vertexBuffer.subarray(ptr + 4, ptr + 8));
                }
            }

            const isText = (this.shaderType[m.textureHandle] == SM_SHADER_TEXT);
            const meshComp = objects[o].getComponent('mesh') || objects[o].addComponent('mesh', {
                mesh: mesh,
                /* Guessing that the first texture is always the font texture */
                material: isText ? this.fontMaterial.clone() : this.material.clone()
            });
            meshComp.mesh = mesh;
            const materialIsText = (meshComp.material.shader == "StoryMachine Text");
            if(isText != materialIsText) {
                meshComp.material = isText ? this.fontMaterial.clone() : this.material.clone()
            }

            /* We offset back by -0.25 to correct for cursor otherwise appearing off */
            objects[o].setTranslationLocal([m.x, m.y, 0.4*m.layer + 0.1*o - 0.25]);
            objects[o].scalingLocal.set([m.scaleX, m.scaleY, 0]);
            objects[o].rotationLocal.set(glMatrix.quat.setAxisAngle([], [0, 0, 1], m.rotationDegrees*(Math.PI/180)));

            meshComp.material.texture = this.textures[m.textureHandle] || this.createTexture(m.textureHandle);
            meshComp.material.tintColor = m.tintColor;
            meshComp.material.uvOffset = [m.uvOffsetScale[0], m.uvOffsetScale[1]];
            meshComp.material.uvScale = [m.uvOffsetScale[2], m.uvOffsetScale[3]];
        }
    },
    clearGraphicsContext: function() {
    },
    update: function() {
        if(this.sm) this.sm.RunFrame();

        this.object.getForward(this.forward);
        WL.scene.activeViews[0].object.getForward(this.viewForward);

        const dot = glMatrix.vec3.dot(this.forward, this.viewForward);
        if(dot <= 0) {
            this.hide();
        } else {
            this.show();
        }
    },
    hide: function() {
        if(this.hidden) return;
        this.hidden = true;

        for(let i = 0; i < this.textures.length; ++i) {
            if(!this.textures[i]) continue;
            this.textures[i].destroy();
            this.textures[i] = null;
        }
    },
    show: function() {
        if(!this.hidden) return;
        this.hidden = false;
    },
});
